/**
 * Genera expresiones base para variables normales:
 * - Si value es base64 → i:path
 * - Si value es string/number/bool → v:path
 */
export function generarExpresionBase(variable) {
  const valor = variable.value

  // Imagen en base64
  if (typeof valor === 'string' && valor.startsWith('data:image/')) {
    return `\${i:${variable.fullPath}}`
  }

  // Cadena base64 larga (probable imagen)
  if (typeof valor === 'string' && valor.length > 40 && /^[A-Za-z0-9+/=]+$/.test(valor)) {
    return `\${i:${variable.fullPath}}`
  }

  // Normal
  return `\${v:${variable.fullPath}}`
}
